import type { SideMenuItenProp } from '@base/react/build/components/sidebar/item/item';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { CONTROL_PANEL_MENU_ITEMS } from '../models/control-panel-menu-model';

export function useControlPanelMenu(onNavigate?: () => void) {
  const { navigateTo, isInRoute } = Sebrae.useRouter();

  const menuItems: SideMenuItenProp[] = React.useMemo(
    () =>
      CONTROL_PANEL_MENU_ITEMS.map(({ label, to }) => ({
        label,
        active: isInRoute(to),
        callback: () => {
          onNavigate?.();
          navigateTo(to);
        },
      })),
    [isInRoute, navigateTo, onNavigate],
  );

  return { menuItems };
}
